export const setCurrencyFormat = (quantityValue) => {
	if (!quantityValue)
		return Number(0)
			.toFixed(2)
			.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  
	return Number(quantityValue)
		.toFixed(2)
		.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};